import { createContext } from 'react';

const newsPostContext = createContext();

export default newsPostContext;
